module.exports = __webpack_public_path__ + "static/media/home-icon.e6f71ae2.svg";